import { History } from "@mui/icons-material";
import { Button, Chip } from "@mui/material";
import { CertificateActions } from "../../CertificateDocs/CertificateActions";
import { DocumentCard } from "../../../../../../components/common/DocumentCard";
import { EhrResponsiveTable } from "../../../mobile/EhrResponsiveTable";
import { useDocumentHistoryColumn } from "./useDocumentHistoryColumn";

export function NoteReport({
  rowData = [],
  handleOpen,
  setBinaryUrl,
  sign,
  setRefetch,
}: any) {
  const { displayRows, historyDialog, openHistory, rowHasHistory } =
    useDocumentHistoryColumn({
      rowData,
      handleOpen,
      setBinaryUrl,
    });

  const columns = [
    { column: "Profissional", rowName: "practitioner" },
    { column: "Emitido em", rowName: "firstDate" },
    { column: "Última remissão", rowName: "lastDateCell" },
    { column: "Histórico", rowName: "historyAction", width: "12%" },
    { column: "Especialidade", rowName: "specialty" },
  ];

  return (
    <>
      <EhrResponsiveTable
        title="Relatórios e atestados"
        hideSectionHeader
        columns={columns}
        rows={displayRows}
        actions={(row: any) => (
          <CertificateActions
            setRefetch={setRefetch}
            row={row}
            handleOpen={handleOpen}
            setBinaryUrl={setBinaryUrl}
          />
        )}
        renderCard={(row: any) => (
          <DocumentCard
            key={row.id ?? row.date}
            title="Relatório médico"
            date={row.firstDate || row.date}
            dateLabel="Emitido em"
            lastDate={rowHasHistory(row) ? row.lastDate : undefined}
            singleIssue={!rowHasHistory(row)}
            practitioner={row.practitioner}
            specialty={row.specialty}
            actions={
              <CertificateActions
                setRefetch={setRefetch}
                row={row}
                handleOpen={handleOpen}
                setBinaryUrl={setBinaryUrl}
              />
            }
          >
            {rowHasHistory(row) ? (
              <Button
                variant="text"
                color="primary"
                startIcon={<History />}
                onClick={() => openHistory(row)}
                sx={{ textTransform: "none", fontWeight: 600 }}
              >
                Histórico
              </Button>
            ) : (
              <Chip
                label="Emissão única"
                variant="outlined"
                sx={{
                  fontWeight: 600,
                  color: "text.secondary",
                  borderColor: "divider",
                }}
              />
            )}
          </DocumentCard>
        )}
      />
      {historyDialog}
    </>
  );
}
